'use strict';

var _ = require('lodash');
var ConfigurationMarketClassFareTransformerFactory = function ConfigurationMarketClassFareTransformerFactory(DataTransformer, momentService) {
  var DEFAULT_EXCLUSION_RULES_BEGIN_DATE = '2000-01-01';
  var DEFAULT_EXCLUSION_RULES_END_DATE = '2100-12-31';
  function ConfigurationMarketClassFareTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-market-class-fare-influences-mode';
    this.priority = 1;
  }
  ConfigurationMarketClassFareTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationMarketClassFareTransformer.constructor = ConfigurationMarketClassFareTransformer;
  ConfigurationMarketClassFareTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationMarketClassFareTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationMarketClassFareTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationMarketClassFareTransformer.prototype.transform = function (data) {
    var faresOverrides = _.get(data, 'domain.results', []);
    var result = [];
    for (var i = 0; i < faresOverrides.length; i++) {
      var fareOverride = faresOverrides[i];
      var exclusion = {
        origin: fareOverride.origin,
        destination: fareOverride.destination,
        cabin: transformFromAsterisk(fareOverride.cabin),
        fareClass: transformFromAsterisk(fareOverride.fareClass),
        pos: fareOverride.pos,
        startRunDate: momentService.of(transformBeginDateFromAsterisk(fareOverride.startRunDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        endRunDate: momentService.of(transformEndDateFromAsterisk(fareOverride.endRunDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        startTravelDate: momentService.of(transformBeginDateFromAsterisk(fareOverride.startTravelDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        endTravelDate: momentService.of(transformEndDateFromAsterisk(fareOverride.endTravelDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        lastUpdatedDate: momentService.of(fareOverride.lastUpdatedDate, momentService.FIELD.LAST_UPDATED_AT),
        lastUpdatedBy: fareOverride.lastUpdatedBy,
        fareThresholdOverride: fareOverride.fareThresholdOverride || 0
      };
      result.push(exclusion);
    }
    return result;
  };
  function transformFromAsterisk(field) {
    return field === '*' ? 'All' : field;
  }
  function transformBeginDateFromAsterisk(field) {
    return field === '*' ? DEFAULT_EXCLUSION_RULES_BEGIN_DATE : field;
  }
  function transformEndDateFromAsterisk(field) {
    return field === '*' ? DEFAULT_EXCLUSION_RULES_END_DATE : field;
  }
  return ConfigurationMarketClassFareTransformer;
};
ConfigurationMarketClassFareTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationMarketClassFareTransformerFactory;